import { ISpecialPlaceList } from 'models/special-place-list.model';

export interface ISpecialPlace {
  id?: number;
  country?: string | null;
  inseeCode?: string | null;
  zipCode?: string | null;
  city?: string | null;
  list?: ISpecialPlaceList;
}

export class SpecialPlace implements ISpecialPlace {
  constructor(
    public id?: number,
    public country?: string | null,
    public inseeCode?: string | null,
    public zipCode?: string | null,
    public city?: string | null,
    public list?: ISpecialPlaceList
  ) {}
}

export function getSpecialPlaceIdentifier(specialPlace: ISpecialPlace): number | undefined {
  return specialPlace.id;
}
